export enum StatsBackedIposBlock {
  Root = 'StatsBackedIpos',
}
